import UserStore from '../../modules/common/UserStore';

const hasAuthority = (requiredAuthority: string) => {
	const user = UserStore.getUser();
	return !!user.authorities.find((authority) => authority === requiredAuthority);
};

export default hasAuthority;
